// O jogo se chamava PokeTFT: copia as preferências salvas com o prefixo antigo
// (idioma, tema, reconexão…) para o prefixo novo. Importado antes de tudo.
try {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key?.startsWith("poketft:")) continue;
    const next = "pokechess:" + key.slice("poketft:".length);
    if (localStorage.getItem(next) === null) localStorage.setItem(next, localStorage.getItem(key) ?? "");
  }
} catch {
  /* sem storage: nada a migrar */
}
export {};
